import * as React from 'react';

import cn from 'classnames';

import { Icon } from '@components';

import { IconClose } from '@icons';

import { IAlertProps } from './types';

import * as s from './Alert.scss';

export const Alert: React.FC<IAlertProps> = ({
	text,
	more,
	className,
	onClose,
}: IAlertProps) => <div className={cn(s.root, className)}>
	<Icon
		className={s.close}
		glyph={IconClose}
		onClick={onClose}
	/>

	<div>{text}</div>

	{more && <a
		className={s.more}
		href={more.url}
		target="_blank"
		rel="noreferrer"
	>
		{more.title}
	</a>}
</div>;
